import { useState, useEffect, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { banners } from '@/mocks/comics';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const startTimer = useCallback(() => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);
  }, []);

  useEffect(() => {
    startTimer();
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [startTimer]);

  const goTo = (index: number) => {
    setCurrent(index);
    startTimer();
  };

  const banner = banners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {banners.map((b, i) => (
        <div
          key={b.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <img
            src={b.bgImage}
            alt={b.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55 z-20"></div>

      <div className="absolute inset-0 z-30 flex items-center">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="max-w-xl">
            <span className="inline-block text-xs font-medium px-3 py-1 rounded-full bg-accent-500/90 text-background-50 mb-4 whitespace-nowrap">
              {banner.badge}
            </span>
            <h1 className="text-3xl md:text-5xl font-bold text-white font-heading mb-3 leading-tight">
              {banner.title}
            </h1>
            <p className="text-sm md:text-base text-white/70 mb-2">{banner.subtitle}</p>
            <p className="text-sm text-white/60 mb-6 max-w-md">{banner.description}</p>
            <div className="flex items-center gap-3">
              <Link
                to={`/comic/${banner.comicSlug}`}
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>立即阅读</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-white/15 hover:bg-white/25 text-white text-sm font-medium rounded-full backdrop-blur-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                浏览全部
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2">
        {banners.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              i === current
                ? 'bg-primary-500 w-6'
                : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`切换到第${i + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}